import React, { FC } from 'react'
import { muiBankTheme, Link } from '@ally/metronome-ui'
import styled from 'styled-components'
import OpenAccountButton from '../OpenAccountButton'
import { AdobeTileContent } from '../../types'
import XLTileGroup from './XLTileGroup'
import { LoadingRow, LoadingTile } from './XLStyledComponents'

const ProductsRatesLink = styled(Link)`
  white-space: normal;
  max-width: 180px;
  padding-right: ${muiBankTheme.space.sm};
`

const StyledWrapper = styled.nav`
  display: flex;
  align-items: center;
  height: 91px;
  width: 100%;
  max-width: 1100px;
  padding: 0 ${muiBankTheme.space.sm};
  margin: 0 auto;
  opacity: 1;
`
interface ComponentProps {
  exploreTiles: AdobeTileContent | null
}

const XLExploreTiles: FC<ComponentProps> = React.memo(({ exploreTiles }) => {
  return (
    <StyledWrapper
      aria-label="Innovative options make reaching your goals possible"
      // eslint-disable-next-line no-underscore-dangle
      data-track-offerid={exploreTiles?._id ?? null}
      data-track-mbox="ally-dashboard-explore-tiles"
    >
      {exploreTiles ? (
        <ProductsRatesLink to="/products-and-rates" text={exploreTiles.title} />
      ) : (
        <LoadingTile data-testid="xl-loading-tile-product-and-rates">
          <LoadingRow />
          <LoadingRow />
          <LoadingRow />
        </LoadingTile>
      )}

      <XLTileGroup data={exploreTiles} />
      <OpenAccountButton />
    </StyledWrapper>
  )
})

export default XLExploreTiles
